import Primary from './Primary';
import Secondary from './Secondary';
import Tertiary from './Tertiary';
import Destructive from './Destructive';
import DestructiveGhost from './DestructiveGhost';
import ActionImage from './ActionImage';

export default {
  Primary,
  Secondary,
  Tertiary,
  Destructive,
  DestructiveGhost,
};

export const PrimaryIconButton = Primary;
export const SecondaryIconButton = Secondary;
export const TertiaryIconButton = Tertiary;
export const DestructiveIconButton = Destructive;
export const DestructiveGhostIconButton = DestructiveGhost;
export const ActionImageIconButton = ActionImage;
